import React from 'react';

import * as FileConstants from 'folder-items/FileConstants';
import NumericInput from 'ui-library/inputs/NumericInput';
import {ElementKeyboardEvent, NumericInputChangeEvent} from 'util/Types';

/** @package */
export interface NumericValueEditorProps {
  autoFocus: boolean;
  defaultValue?: FileConstants.SchemaTag;
  onChange: (value: Partial<FileConstants.SchemaTag>) => void;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
  placeholder?: string;
  valueAccessorKey: keyof FileConstants.SchemaTag;
  useStringValue?: boolean;
  validateInteger?: boolean;
  isDisabled?: boolean;
}

class NumericValueEditor extends React.Component<NumericValueEditorProps> {
  _handleChange = (e: NumericInputChangeEvent): void => {
    const proposedValue =
      this.props.useStringValue || e.target.numericValue == null ? e.target.value : e.target.numericValue;
    this.props.onChange({
      [this.props.valueAccessorKey]: proposedValue === '' ? null : proposedValue,
      value: e.target.value,
    });
  };

  override render(): JSX.Element {
    const value = this.props.defaultValue ? this.props.defaultValue.value : null;
    return (
      <NumericInput
        focusOnMount={this.props.autoFocus}
        onKeyDown={this.props.onKeyDown}
        onChange={this._handleChange}
        placeholder={this.props.placeholder}
        value={value}
        validateInteger={this.props.validateInteger}
        isDisabled={this.props.isDisabled}
      />
    );
  }
}

export default NumericValueEditor;
